export default __webpack_public_path__ + "static/media/infoIcon.c384c502.svg";